import { Link } from 'react-router-dom';
import Certifications from './Certifications';
import Hero from './Hero';
import ProjectsGrid from './ProjectsGrid';
import Skills from './Skills';
import Tools from './Tools';

function Home() {
    return (
        <main className="overflow-x-hidden">
            <Hero />
            <section className="relative pb-12 pt-24 lg:py-36">
                <picture className="pointer-events-none absolute inset-0 -z-10">
                    <img src="img/gradient_creative.jpg" alt="gradient" className="h-full w-full" />
                </picture>
                <div className="container">
                    <div className="mb-20 text-center">
                        <h1 className="font-display text-5xl text-white lg:text-6xl">Projects</h1>
                        <p className="text-lg leading-normal text-khi-50 text-center">Projects are where imagination meets functionality.</p>
                    </div>
                    <div className="projects-section relative px-6 pb-16 sm:px-0">
                        <ProjectsGrid size="9" />
                        <div className="text-center mt-10 text-2xl">
                            <Link to="/projects" className="text-white">Show More</Link>
                        </div>
                    </div>
                </div>
            </section>
            <section className="relative pt-10 pb-24">
                <picture
                    className="pointer-events-none absolute inset-0 -z-10 after:absolute after:bottom-0 after:h-1/3 after:w-full after:bg-gradient-to-t after:from-[#010107]">
                    <img src="img/gradient_creative.jpg" alt="gradient" className="h-full w-full -scale-y-100" />
                </picture>
                <div className="container">
                    <div className="mb-20 text-center">
                        <h1 className="font-display text-5xl text-white lg:text-6xl">Skills</h1>
                        <p className="text-lg leading-normal text-khi-50 text-center">Every line of code is a step towards turning ideas into reality.</p>
                    </div>
                    <Skills />
                </div>
            </section>
            <section className="home-page-tools-section bg-[#010107] py-12 lg:pb-32">
                <div className="container">
                    <div className="mb-20 text-center">
                        <h1 className="font-display text-5xl text-white lg:text-6xl">Tools and Technologies</h1>
                        <p className="text-lg leading-normal text-khi-50 text-center">Tools and Technologies That I Used in My Career.</p>
                    </div>
                    <Tools />
                </div>
            </section>
            <section className="home-page-tools-section bg-[#010107] py-12 lg:pb-32">
                <img src="img/gradient-circle.png" alt="gradient" className="home-page-tools-section-bg" />
                <div className="container">
                    <div className="mb-20 text-center">
                        <h1 className="font-display text-5xl text-white lg:text-6xl">Certifications</h1>
                        {/* <p className="text-lg leading-normal text-khi-50 text-center">Tools and Technologies That I Used in My Career.</p> */}
                    </div>
                    <Certifications />
                </div>
            </section>
        </main >
    )
}

export default Home